import { createAction, props } from "@ngrx/store";
import { IReleaseNotes } from "@skills-app/models/release-notes";

const prefix = "[Update Release Notes Page]";

export const requestUpdateReleaseNote = createAction(
  `${prefix} Request Update Release Note`,
  props<{ releaseNotes: IReleaseNotes }>(),
);
